import React from 'react';
import { Breadcrumb, Space, Typography } from 'antd';
import { Link } from 'react-router-dom';

const { Title, Text } = Typography;

export const RESERVATION_SUCCESS_DASHBOARD_PATH = '/reservation-success';

interface Props {
  title: React.ReactNode;
  description?: React.ReactNode;
  extra?: React.ReactNode;
  parent?: { label: string; to: string };
  isDashboard?: boolean;
}

const ReservationSuccessPageHeader: React.FC<Props> = ({ title, description, extra, parent, isDashboard }) => {
  const items = isDashboard
    ? [{ title: '예약 성사' }]
    : [
        { title: <Link to={RESERVATION_SUCCESS_DASHBOARD_PATH}>예약 성사 대시보드</Link> },
        ...(parent ? [{ title: <Link to={parent.to}>{parent.label}</Link> }] : []),
        { title },
      ];

  return (
    <div style={{ marginBottom: 16 }}>
      <Breadcrumb items={items} style={{ marginBottom: 8 }} />
      <Space style={{ width: '100%', justifyContent: 'space-between' }} align="start" wrap>
        <div>
          <Title level={3} style={{ margin: 0 }}>
            {title}
          </Title>
          {description && (
            <Text type="secondary" style={{ display: 'block', marginTop: 4 }}>
              {description}
            </Text>
          )}
        </div>
        {extra}
      </Space>
    </div>
  );
};

export default ReservationSuccessPageHeader;
